import { render, staticRenderFns } from "./propertyAssetForm.vue?vue&type=template&id=6ca347b2&%23default=true&"
import script from "./propertyAssetForm.vue?vue&type=script&lang=js&"
export * from "./propertyAssetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports